export default __webpack_public_path__ + "static/media/starter-elementals-1.e6ab3172.png";